// extracted by mini-css-extract-plugin
export default {"searchInputBox":"SearchInput_searchInputBox__msgn4","searchIcon":"SearchInput_searchIcon__k5wpJ","labelText":"SearchInput_labelText__5uePN"};